import { render, staticRenderFns } from "./seller-belt.vue?vue&type=template&id=328bfb71&"
import script from "./seller-belt.vue?vue&type=script&lang=js&"
export * from "./seller-belt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports